import React from 'react';
import { formatTemplatePageLabel } from '../lib/vmkQuoteDocumentLayout';

const publicUrl = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

const VmkPhoneIcon = () => (
  <svg
    className="vmk-template-footer-icon"
    width={12}
    height={12}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M8.5 4.5h2.8c.5 0 .9.3 1 .8l.6 3.1a1 1 0 0 1-.3 1l-1.7 1.7a12.5 12.5 0 0 0 5.4 5.4l1.7-1.7a1 1 0 0 1 1-.3l3.1.6c.5.1.8.5.8 1V18a1.5 1.5 0 0 1-1.5 1.5C10.8 19.5 4.5 13.2 4.5 6A1.5 1.5 0 0 1 6 4.5h2.5z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VmkBrandedPageHeader = ({ pageNumber, className = '', children }) => (
  <header className={`vmk-proposal-header ${className}`.trim()}>
    <img
      src={publicUrl('/images/vmk-kozijnen-logo.png')}
      alt="VMK Kozijnen"
      className="vmk-proposal-logo"
    />
    <div className="vmk-proposal-badge">{formatTemplatePageLabel(pageNumber)}</div>
    {children}
  </header>
);

export const VmkTemplateFooter = ({ className = '' }) => (
  <footer className={`vmk-template-footer ${className}`.trim()}>
    <span className="vmk-template-footer-item">
      <VmkPhoneIcon />
      074 - 234 03 33
    </span>
    <span className="vmk-template-footer-item">info@vmkkozijnen.nl</span>
    <span className="vmk-template-footer-item">www.vmkkozijnen.nl</span>
  </footer>
);

export const VmkTemplateContactBar = ({ className = '' }) => (
  <div className={`vmk-template-contact-bar ${className}`.trim()}>
    <span className="vmk-template-footer-item">
      <VmkPhoneIcon />
      074 - 234 03 33
    </span>
    <span className="vmk-template-footer-item">info@vmkkozijnen.nl</span>
    <span className="vmk-template-footer-item">www.vmkkozijnen.nl</span>
  </div>
);
